import React, { memo } from "react";
import useStyles from "./styles";
import NoneData from "components/NoneData";
import HeaderHistoryOrder from "../HeaderHistoryOrder";
import BodyHistoryOrder from "../BodyHistoryOrder";

import { Grid } from "@material-ui/core";

const HistoryOrderItem = memo(props => {
	const classes = useStyles();
	const { listOrder, handleSeeDetails, isMobile, heightBody, business } =
		props;

	const listOrderFormat = listOrder?.sort(function (a, b) {
		return new Date(b?.createTime) - new Date(a?.createTime);
	});

	const handleShowDefault = id => {
		const data = {
			id: id,
			business: business
		};
		handleSeeDetails(data);
	};

	return (
		<Grid classes={{ root: classes.root }} style={{ height: heightBody }}>
			<Grid id="listHistoryOrder" />
			{!!listOrderFormat ? (
				listOrderFormat.map(product => (
					<Grid classes={{ root: classes.history }} key={product?.id}>
						<Grid classes={{ root: classes.historyItem }}>
							<HeaderHistoryOrder item={product} />
							<BodyHistoryOrder
								products={product?.items}
								finalAmount={product?.finalAmount || 0}
								productId={product?.id}
								handleShowDefault={handleShowDefault}
							/>
						</Grid>
					</Grid>
				))
			) : (
				<Grid
					classes={{ root: classes.centerPage }}
					style={{ height: isMobile ? heightBody : 0 }}
				>
					<NoneData />
				</Grid>
			)}
		</Grid>
	);
});

export default HistoryOrderItem;
